import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { forkJoin, reduce, Subject, of } from 'rxjs';
import { formatDate } from '@angular/common';
import { ChangePasswordDialogComponent } from './profile-information/change-password-dialog/change-password-dialog.component';
import { catchError } from 'rxjs/operators';
import { CountryAffiliationComponent } from './country-affiliation/country-affiliation.component';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserService } from 'src/app/core/services/user.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent {

  @Input() profileData: any;
  @Input() profileImg: any;
  @ViewChild('editForm') editForm!: NgForm;
  isEditMode = false;
  files: any;
  @Input() profGen: any;
  originalProfileData: any = {};
  today: any;
  editableProfileData: any = {};
  countryCode: any = '';
  countryMap: any = {
    AE: { mobile: '+971', flag: '🇦🇪' },
    AR: { mobile: '+54', flag: '🇦🇷' },
    AU: { mobile: '+61', flag: '🇦🇺' },
    BE: { mobile: '+32', flag: '🇧🇪' },
    BD: { mobile: '+880', flag: '🇧🇩' },
    BR: { mobile: '+55', flag: '🇧🇷' },
    CA: { mobile: '+1', flag: '🇨🇦' },
    CH: { mobile: '+41', flag: '🇨🇭' },
    CN: { mobile: '+86', flag: '🇨🇳' },
    DE: { mobile: '+49', flag: '🇩🇪' },
    ES: { mobile: '+34', flag: '🇪🇸' },
    ET: { mobile: '+251', flag: '🇪🇹' },
    FR: { mobile: '+33', flag: '🇫🇷' },
    GB: { mobile: '+44', flag: '🇬🇧' },
    GH: { mobile: '+233', flag: '🇬🇭' },
    ID: { mobile: '+62', flag: '🇮🇩' },
    IN: { mobile: '+91', flag: '🇮🇳' },
    IT: { mobile: '+39', flag: '🇮🇹' },
    JP: { mobile: '+81', flag: '🇯🇵' },
    KE: { mobile: '+254', flag: '🇰🇪' },
    KR: { mobile: '+82', flag: '🇰🇷' },
    LK: { mobile: '+94', flag: '🇱🇰' },
    MX: { mobile: '+52', flag: '🇲🇽' },
    MY: { mobile: '+60', flag: '🇲🇾' },
    NG: { mobile: '+234', flag: '🇳🇬' },
    NL: { mobile: '+31', flag: '🇳🇱' },
    NP: { mobile: '+977', flag: '🇳🇵' },
    NZ: { mobile: '+64', flag: '🇳🇿' },
    PK: { mobile: '+92', flag: '🇵🇰' },
    PH: { mobile: '+63', flag: '🇵🇭' },
    RU: { mobile: '+7', flag: '🇷🇺' },
    SA: { mobile: '+966', flag: '🇸🇦' },
    SG: { mobile: '+65', flag: '🇸🇬' },
    SE: { mobile: '+46', flag: '🇸🇪' },
    TH: { mobile: '+66', flag: '🇹🇭' },
    TZ: { mobile: '+255', flag: '🇹🇿' },
    US: { mobile: '+1', flag: '🇺🇸' },
    VN: { mobile: '+84', flag: '🇻🇳' },
    ZA: { mobile: '+27', flag: '🇿🇦' }
  };
  countryNameToCode: any = {
    UnitedArabEmirates: 'AE',
    Argentina: 'AR',
    Australia: 'AU',
    Belgium: 'BE',
    Bangladesh: 'BD',
    Brazil: 'BR',
    Canada: 'CA',
    Switzerland: 'CH',
    China: 'CN',
    Germany: 'DE',
    Spain: 'ES',
    Ethiopia: 'ET',
    France: 'FR',
    UnitedKingdom: 'GB',
    Ghana: 'GH',
    Indonesia: 'ID',
    India: 'IN',
    Italy: 'IT',
    Japan: 'JP',
    Kenya: 'KE',
    KoreaRepublicof: 'KR',
    SriLanka: 'LK',
    Mexico: 'MX',
    Malaysia: 'MY',
    Nigeria: 'NG',
    Netherlands: 'NL',
    Nepal: 'NP',
    NewZealand: 'NZ',
    Pakistan: 'PK',
    Philippines: 'PH',
    RussianFederation: 'RU',
    SaudiArabia: 'SA',
    Singapore: 'SG',
    Sweden: 'SE',
    Thailand: 'TH',
    TanzaniaUnitedRepublicof: 'TZ',
    UnitedStates: 'US',
    VietNam: 'VN',
    SouthAfrica: 'ZA'
  };
  showCamera = false;
  profileImage: string | null = null;
  videoStream: MediaStream | null = null;
  healthProfileId: string | null = null;
  countries = [
    { name: 'United States', code: 'US' },
    { name: 'India', code: 'IN' },
  ];

  // Login type handling
  loginType: 'email' | 'mobile' | null = null;
  isEmailReadonly: boolean = false;
  isMobileReadonly: boolean = false;

  validationErrors: any = {};

  tday = new Date();
  datePickerConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'MMM DD, YYYY',
    containerClass: 'theme-dark-blue',
    showWeekNumbers: false,
    minDate: new Date(1900, 0, 1),
    maxDate: new Date()
  };

  // ===== PASSWORD SECTION PROPERTIES =====
  hasPassword: boolean = false;
  showPasswordSection: boolean = false;
  showCurrentPwd: boolean = false;
  showNewPwd: boolean = false;
  showConfirmPwd: boolean = false;
  passwordData = { current: '', newPwd: '', confirmPwd: '' };
  passwordErrors: any = {};
  private passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,15}$/;
  // ===== END PASSWORD SECTION PROPERTIES =====

  constructor(
    private userService: UserService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private auth: AuthService,
    private dataService: DataService,
    private router: Router,
    private toast: ToastrService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.profileData = {
      first_name: '',
      last_name: '',
      gender: '',
      dob: '',
      email: '',
      mobile: '',
      countryCode: '',
      country: '',
      home_address: '',
      work_address: ''
    };

    this.originalProfileData = JSON.parse(JSON.stringify(this.profileData));

    this.loginType = localStorage.getItem('login_type') as 'email' | 'mobile' | null;
    this.setReadonlyFields();

    // Determine if user already has a password set.
    // Users who registered/logged in via email have a password.
    // You can also check a backend field like profile.has_password if available.

    this.getProfile();

    const now = new Date();
    this.today = now.toISOString().split('T')[0];
  }

  setReadonlyFields() {
    if (this.loginType === 'email') {
      this.isEmailReadonly = true;
      this.isMobileReadonly = false;
    } else if (this.loginType === 'mobile') {
      this.isEmailReadonly = false;
      this.isMobileReadonly = true;
    } else {
      this.isEmailReadonly = false;
      this.isMobileReadonly = false;
    }
  }

  getProfile() {
    this.auth.get_digicoffer_profile().subscribe((user: any) => {
      const profile = user.data.profile;
      const citizenData = profile?.citizen?.[0] || {};

      const cleanValue = (val: any): string => {
        if (val === null || val === undefined) return '';
        const strVal = String(val).trim();
        if (strVal === 'null' || strVal === 'undefined' || strVal === '') return '';
        return strVal;
      };

      const apiFirst  = cleanValue(profile?.first_name);
      const apiLast   = cleanValue(profile?.last_name);
      const apiEmail  = cleanValue(profile?.email);
      const apiMobile = cleanValue(profile?.mobile);

      this.profileData = {
        first_name:   apiFirst  || cleanValue(localStorage.getItem('first_name')),
        last_name:    apiLast   || cleanValue(localStorage.getItem('last_name')),
        gender:       cleanValue(profile?.gender) || cleanValue(user?.data?.gender),
        dob: cleanValue(profile?.dob) ? this.convertDOBToDate(cleanValue(profile?.dob)) : null,
        email:        apiEmail  || cleanValue(localStorage.getItem('email')),
        mobile:       apiMobile || cleanValue(localStorage.getItem('mobile')),
        country:      cleanValue(citizenData?.country) || 'India',
        home_address: cleanValue(citizenData?.home_address),
        work_address: cleanValue(citizenData?.work_address)
      };
      this.hasPassword = cleanValue(profile?.password_last_changed) ? true : false;

      // Lock Email and Mobile once the API returns a value for them, regardless
      // of which identifier was used to log in. Previously only the field
      // matching login_type was locked; both must be locked whenever populated.
      this.isEmailReadonly = !!apiEmail;
      this.isMobileReadonly = !!apiMobile;

      const countryName = (citizenData?.country || 'Australia').replace(/\s+/g, '');
      if (countryName && this.countryNameToCode[countryName]) {
        this.countryCode = this.countryNameToCode[countryName];
      } else {
        this.countryCode = 'AU';
      }
      this.profileData.countryCode = this.countryMap[this.countryCode]?.mobile || '+91';

      // If the API returns a has_password field, use it to override loginType detection.
      // Uncomment the line below if your backend exposes this field:
      // if (profile?.has_password !== undefined) this.hasPassword = !!profile.has_password;

      this.originalProfileData = JSON.parse(JSON.stringify(this.profileData));
    });

    this.auth.get_image().subscribe((img: any) => {
      this.profileImg = img.data.imageUrl;
    });
  }

  convertToDateInputFormat(dob: string): string {
    if (!dob) return '';
    const parts = dob.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dob;
  }

  convertDOBToDate(dobString: string): Date | null {
    if (!dobString) return null;
    const parts = dobString.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      try {
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      } catch (e) {
        return null;
      }
    }
    try {
      return new Date(dobString);
    } catch (e) {
      return null;
    }
  }

  toggleEdit() {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.editableProfileData = JSON.parse(JSON.stringify(this.profileData));
      this.validationErrors = {};
      // Reset password section when entering edit mode
      this.showPasswordSection = false;
      this.passwordData = { current: '', newPwd: '', confirmPwd: '' };
      this.passwordErrors = {};
      this.showCurrentPwd = false;
      this.showNewPwd = false;
      this.showConfirmPwd = false;
    }
  }

  changePhoto(fileInput: HTMLInputElement): void {
    fileInput.click();
  }

  removePhoto() {
    this.profileImg = null;
  }

  onSubmit() {
    this.validationErrors = {};

    // Profile field validation
    if (!this.profileData.first_name || this.profileData.first_name.trim() === '') {
      this.validationErrors['first_name'] = true;
    }
    if (!this.profileData.last_name || this.profileData.last_name.trim() === '') {
      this.validationErrors['last_name'] = true;
    }
    if (!this.profileData.email || this.profileData.email.trim() === '') {
      this.validationErrors['email'] = true;
    } else if (!this.isValidEmail(this.profileData.email)) {
      this.validationErrors['email_format'] = true;
    }
    if (!this.profileData.mobile || this.profileData.mobile.trim() === '') {
      this.validationErrors['mobile'] = 'required';
    } else if (!/^\d{10}$/.test(this.profileData.mobile)) {
      this.validationErrors['mobile'] = 'invalid';
    }
    if (!this.profileData.home_address || this.profileData.home_address.trim() === '') {
      this.validationErrors['home_address'] = true;
    }

    if (Object.keys(this.validationErrors).length > 0) {
      return;
    }

    this.submitProfile();
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private submitProfile() {
    const firstName = this.profileData.first_name.trim();
    const lastName  = this.profileData.last_name.trim();

    localStorage.setItem('first_name', firstName);
    localStorage.setItem('last_name', lastName);
    localStorage.setItem('full_name', `${firstName} ${lastName}`);

    if (this.profileData.email)  localStorage.setItem('email', this.profileData.email);
    if (this.profileData.mobile) localStorage.setItem('mobile', this.profileData.mobile);

    let formattedDob2;
    if (this.profileData.dob) {
      const dobDate = new Date(this.profileData.dob);
      if (!isNaN(dobDate.getTime())) {
        formattedDob2 = this.datePipe.transform(dobDate, 'dd-MM-yyyy');
      }
    }

    const citizenIndex = 'citizen_primary';

    const profilePayload = {
      first_name:           firstName,
      last_name:            lastName,
      gender:               this.profileData.gender,
      dob:                  formattedDob2,
      email:                this.profileData.email,
      mobile:               this.profileData.mobile,
      password:             '',
      password_last_changed:'',
      countryCode:          this.profileData.countryCode
    };

    const addressPayload = {
      country:          this.profileData.country,
      affiliation_type: 'citz',
      mobile_phone:     this.profileData.mobile,
      home_address:     this.profileData.home_address || '',
      alt_phone:        '',
      work_phone:       '',
      work_address:     this.profileData.work_address || ''
    };

    this.auth.edit_country(citizenIndex, addressPayload).subscribe(
      (addressRes: any) => {
        if (addressRes?.error !== false) {
          this.toast.warning(addressRes?.msg || 'Address update failed');
          return;
        }

        this.auth.update_digicoffer_profile(profilePayload).subscribe(
          (profileRes: any) => {
            if (profileRes?.error === false) {
              const fullName = `${firstName} ${lastName}`;
              localStorage.setItem('full_name', fullName);
              this.userService.updateFullName(fullName);

              this.toast.success(profileRes?.msg || 'Profile updated successfully');
              this.isEditMode = false;
              this.validationErrors = {};

              this.getProfile();
            } else {
              this.toast.error(profileRes?.msg || 'Failed to update profile');
            }
          },
          (err) => {
            console.error('Profile update error:', err);
            this.toast.error(err?.error?.msg || 'Failed to update profile');
          }
        );
      },
      (err) => {
        console.error('Address update error:', err);
        this.toast.error(err?.error?.msg || 'Failed to update address');
      }
    );
  }

  hasProfileChanged(): boolean {
    return JSON.stringify(this.editableProfileData) !== JSON.stringify(this.originalProfileData);
  }

  onCancel(): void {
    this.validationErrors = {};

    const hasChanges = JSON.stringify(this.profileData) !== JSON.stringify(this.originalProfileData);
    const hasPasswordInput = this.showPasswordSection &&
      (this.passwordData.current || this.passwordData.newPwd || this.passwordData.confirmPwd);

    if (hasChanges || hasPasswordInput) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '350px',
        height: '200px',
        disableClose: true,
        data: { message: 'You have unsaved changes. Do you want to discard them?' },
        panelClass: 'custom-dialog-container'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.profileData = JSON.parse(JSON.stringify(this.originalProfileData));
          this.isEditMode = false;
          // Reset password section
          this.showPasswordSection = false;
          this.passwordData = { current: '', newPwd: '', confirmPwd: '' };
          this.passwordErrors = {};
        }
      });
    } else {
      this.isEditMode = false;
    }
  }

  openChangePasswordDialog() {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '550px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getProfile();
    });
  }

  onFileChanged(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      this.toast.error('Must be an image (JPEG, PNG, or JPG)');
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      this.toast.error('File size exceeds 2 MB');
      return;
    }

    this.files = file;
    this.onUpload();
  }

  onUpload() {
    const formData = new FormData();
    formData.append('file', this.files);
    this.auth.upload_image(formData).subscribe((res: any) => {
      if (res.error == false) {
        this.toast.success('Profile updated successfully');
        this.auth.get_image().subscribe((res: any) => {
          if (res) {
            this.profileImg = res.data.imageUrl;
            this.dataService.setProfilePic(this.profileImg);
          }
        });
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/consumer', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
    });
  }

  onDelete() {
    const formData = new FormData();
    formData.append('file', this.files);
    this.auth.delete_image(formData).subscribe((res: any) => {
      if (res.error == false) {
        this.toast.success('Profile updated successfully');
        this.auth.get_image().subscribe((res: any) => {
          if (res) {
            this.profileImg = res.data.imageUrl;
            this.dataService.setProfilePic(this.profileImg);
          }
        });
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/consumer', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault();
    }
  }

  preventInvalidStart(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (input.selectionStart === 0) {
      const char = event.key;
      if (!/^[a-zA-Z]$/.test(char) && char.length === 1) {
        event.preventDefault();
      }
    }
  }

  validateName(fieldName: 'first_name' | 'last_name') {
    if (this.profileData[fieldName]) {
      this.profileData[fieldName] = this.profileData[fieldName].replace(/^[^a-zA-Z]+/, '');
      this.profileData[fieldName] = this.profileData[fieldName].replace(/[^a-zA-Z\s]/g, '');
    }
  }

  openCamera() {
    this.showCamera = true;
    navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
      this.videoStream = stream;
      const video: any = document.querySelector('video');
      if (video) {
        video.srcObject = stream;
      }
    });
  }

  capturePhoto(video: HTMLVideoElement) {
    const canvas: any = document.querySelector('canvas');
    const context = canvas.getContext('2d');
    canvas.width  = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    this.profileImage = canvas.toDataURL('image/png');

    canvas.toBlob((blob: any) => {
      if (blob) {
        const file = new File([blob], 'photo.png', { type: 'image/png' });
        this.uploadCapturedImage(file);
      }
    }, 'image/png');

    this.closeCamera();
  }

  closeCamera() {
    this.showCamera = false;
    if (this.videoStream) {
      this.videoStream.getTracks().forEach((track) => track.stop());
    }
  }

  uploadCapturedImage(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    this.auth.upload_image(formData).subscribe((res: any) => {
      if (res.error == false) {
        this.toast.success('Profile updated successfully');
        this.auth.get_image().subscribe((res: any) => {
          if (res) {
            this.profileImg = res.data.imageUrl;
          }
        });
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/consumer', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
    });
  }

  clearError(field: string) {
    const value = this.profileData[field];
    if (!value || value.trim() === '') {
      this.validationErrors[field] = 'required';
    } else if (field === 'mobile' && !/^\d{10}$/.test(value)) {
      this.validationErrors[field] = 'invalid';
    } else {
      this.validationErrors[field] = false;
    }
  }

  // ===== PASSWORD SECTION METHODS =====

  togglePasswordSection() {
    this.showPasswordSection = !this.showPasswordSection;
    if (!this.showPasswordSection) {
      // Clear everything when collapsing
      this.passwordData = { current: '', newPwd: '', confirmPwd: '' };
      this.passwordErrors = {};
      this.showCurrentPwd  = false;
      this.showNewPwd      = false;
      this.showConfirmPwd  = false;
    }
  }

  preventPwdSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  validateNewPassword(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    if (!val) {
      this.passwordErrors['newPwd'] = 'New Password is required';
    } else if (!this.passwordPattern.test(val)) {
      this.passwordErrors['newPwd'] =
        'Must be 8–15 characters with at least 1 uppercase, 1 lowercase, 1 number & 1 special character';
    } else {
      this.passwordErrors['newPwd'] = null;
    }
    if (this.passwordData.confirmPwd) {
      this.validateConfirmPassword();
    }
  }

  validateConfirmPassword() {
    if (!this.passwordData.confirmPwd?.trim()) {
      this.passwordErrors['confirmPwd'] = 'Please re-type your new password';
    } else if (this.passwordData.newPwd !== this.passwordData.confirmPwd) {
      this.passwordErrors['confirmPwd'] = 'Passwords do not match';
    } else {
      this.passwordErrors['confirmPwd'] = null;
    }
  }

  onUpdatePasswordClick() {
    if (!this.validatePasswordSection()) {
      return;
    }
    this.submitPassword();
  }

  clearPwdError(field: string) {
    this.passwordErrors[field] = null;
  }

  private validatePasswordSection(): boolean {
    this.passwordErrors = {};
    let valid = true;

    // Current password required only when updating existing password
    if (this.hasPassword && !this.passwordData.current?.trim()) {
      this.passwordErrors['current'] = true;
      valid = false;
    }

    // New password
    if (!this.passwordData.newPwd?.trim()) {
      this.passwordErrors['newPwd'] = 'New Password is required';
      valid = false;
    } else if (!this.passwordPattern.test(this.passwordData.newPwd)) {
      this.passwordErrors['newPwd'] =
        'Must be 8–15 characters with at least 1 uppercase, 1 lowercase, 1 number & 1 special character';
      valid = false;
    }

    // Confirm password
    if (!this.passwordData.confirmPwd?.trim()) {
      this.passwordErrors['confirmPwd'] = 'Please re-type your new password';
      valid = false;
    } else if (this.passwordData.newPwd !== this.passwordData.confirmPwd) {
      this.passwordErrors['confirmPwd'] = 'Passwords do not match';
      valid = false;
    }

    // New password must differ from current
    if (
      this.hasPassword &&
      this.passwordData.current?.trim() &&
      this.passwordData.newPwd?.trim() &&
      this.passwordData.current === this.passwordData.newPwd
    ) {
      this.passwordErrors['newPwd'] = 'New password cannot be the same as current password';
      valid = false;
    }

    return valid;
  }

  private submitPassword(): void {
    const payload = {
      field: 'password',
      old:   this.passwordData.current,
      new:   this.passwordData.newPwd
    };

    this.auth.update_password(payload).subscribe(
      (res: any) => {
        if (res?.error === false) {
          this.toast.success(res?.msg || 'Password updated successfully');
          // Reset password section
          this.showPasswordSection = false;
          this.passwordData = { current: '', newPwd: '', confirmPwd: '' };
          this.passwordErrors = {};
          this.showCurrentPwd  = false;
          this.showNewPwd      = false;
          this.showConfirmPwd  = false;
          // Once a password is set, always show "Update Password" going forward
          this.hasPassword = true;
        } else {
          this.toast.error(res?.msg || 'Failed to update password');
        }
      },
      (err: HttpErrorResponse) => {
        this.toast.error(err?.error?.msg || 'Failed to update password');
      }
    );
  }

  // ===== END PASSWORD SECTION METHODS =====
}